module.exports = __webpack_public_path__ + "static/media/map-marker-alt-solid.06896b54.png";